import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
let PerPage = class PerPage extends Vue {
    value;
    defaultValue;
    perPageLabel = [5, 10, 20, 50, 100];
    emitInput(val) {
        return val;
    }
};
__decorate([
    Prop({})
], PerPage.prototype, "value", void 0);
__decorate([
    Prop({ default: 10 })
], PerPage.prototype, "defaultValue", void 0);
__decorate([
    Emit('input')
], PerPage.prototype, "emitInput", null);
PerPage = __decorate([
    Component({})
], PerPage);
export default PerPage;
